import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    viewChild,
} from '@angular/core';
import SignaturePad from 'signature_pad';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/shared/material/material.module';

@Component({
    selector: 'app-signature-pad-dialog',
    templateUrl: './signature-pad-dialog.component.html',
    styleUrl: './signature-pad-dialog.component.scss',
    imports: [CommonModule, MaterialModule, TranslateModule],
})
export class SignaturePadDialogComponent implements AfterViewInit {
    signaturePadElement =
        viewChild.required<ElementRef<HTMLCanvasElement>>('signaturePad');
    signaturePad!: SignaturePad;
    private context!: CanvasRenderingContext2D;
    isSignatureEmpty: boolean = true;

    constructor(
        private dialogRef: MatDialogRef<SignaturePadDialogComponent>,
        private dialog: MatDialog,
        private translateService: TranslateService,
        private cdr: ChangeDetectorRef
    ) {}

    ngAfterViewInit(): void {
        this.signaturePad = new SignaturePad(
            this.signaturePadElement().nativeElement,
            {
                backgroundColor: '#fff',
                minWidth: 50,
                dotSize: 1,
            }
        );
        this.context = this.signaturePadElement().nativeElement.getContext(
            '2d'
        ) as CanvasRenderingContext2D;

        this.resizeCanvas();

        this.updateSignatureState();
    }

    clearPad() {
        this.signaturePad?.clear();
        this.updateSignatureState();
    }

    closePad() {
        this.dialogRef.close();
    }

    savePad() {
        this.dialogRef.close(this.signaturePad.toDataURL());
    }

    @HostListener('window:resize')
    onResize(): void {
        this.resizeCanvas();
    }

    private resizeCanvas(): void {
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const nativeElement = this.signaturePadElement().nativeElement;
        nativeElement.width = nativeElement.offsetWidth * ratio;
        nativeElement.height = nativeElement.offsetHeight * ratio;
        this.context.scale(ratio, ratio);
        this.clearPad();
    }

    private updateSignatureState() {
        this.isSignatureEmpty = this.signaturePad.isEmpty();
        this.cdr.detectChanges();
    }

    isNotSigned(): boolean {
        return this.isSignatureEmpty;
    }
}
